import { Link, useNavigate } from "react-router-dom";

import {
  useGetEstimatedQuoteMutation,
  useRequestLogisticsQuotesMutation,
} from "../../store/apiSlices/logistics";
import EstimatedQuoteCard from "../../components/Logistics/EstimatedQuoteCard";
import QuoteForm from "../../components/Logistics/QuoteForm";
import { SimpleBookingFormType } from "../../components/Logistics/SimpleBooking";
import EstimatedQuoteCardSkeleton from "../../components/Logistics/EstimatedQuoteCardSkeleton ";
import { getItemFromLocalStore } from "../../utils";
import { toast } from "react-toastify";

export default function Quotes() {
  const navigate = useNavigate();

  const [getEstimatedQuote, { isLoading, data: quotesData }] =
    useGetEstimatedQuoteMutation();

  const onSubmitHandler = async (values: SimpleBookingFormType) => {
    localStorage.setItem("cargo-details", JSON.stringify(values));

    const payload = {
      from: `${values.from_json.name}, ${values.from_json.countryCode}`,
      to: `${values.to_json.name}, ${values.to_json.countryCode}`,
      type: values.freight_type,
      weight: values.weight,
    };

    await getEstimatedQuote(payload);
  };

  const [requestLogisticsQuotes, { isLoading: isRequestLoading }] =
    useRequestLogisticsQuotesMutation();

  const handleRequestQuotes = async (openSuccess: () => void) => {
    const persistedData = getItemFromLocalStore("cargo-details");

    const payload = {
      ...persistedData,
      ai_response: quotesData,
    };

    const { data: res } = await requestLogisticsQuotes(payload);

    if (res.status === "success") {
      // quotesSuccessDialogRef.current?.showModal();
      openSuccess();
    } else {
      toast.error(
        res?.msg || res?.message || "Something went wrong, try again!"
      );
    }
  };

  return (
    <section className="pl-10 space-y-6">
      <QuoteForm onSubmit={onSubmitHandler} isLoading={isLoading} />

      {isLoading ? (
        <EstimatedQuoteCardSkeleton />
      ) : quotesData ? (
        <EstimatedQuoteCard data={quotesData}>
          {(action) => (
            <>
              <EstimatedQuoteCard.Body>
                <EstimatedQuoteCard.Header>
                  <EstimatedQuoteCard.Title />

                  <EstimatedQuoteCard.Action>
                    <EstimatedQuoteCard.Price />
                    <EstimatedQuoteCard.RequestBtn
                      handleClick={() =>
                        handleRequestQuotes(action.openSuccess)
                      }
                      isLoading={isRequestLoading}
                    />
                  </EstimatedQuoteCard.Action>
                </EstimatedQuoteCard.Header>

                <EstimatedQuoteCard.Route />
                <EstimatedQuoteCard.Details />
                <EstimatedQuoteCard.CostBreakdown />
              </EstimatedQuoteCard.Body>

              <EstimatedQuoteCard.SuccessDialog ref={action.dialogRef}>
                <Link
                  to="/dashboard"
                  className="w-full flex justify-center items-center gap-2 bg-custom-blue-medium text-white font-semibold py-2.5 rounded-lg shadow-md hover:bg-custom-blue/90 focus:ring-2 focus:ring-blue-300 focus:outline-none transition-all duration-200"
                >
                  Go to Dashboard
                </Link>
              </EstimatedQuoteCard.SuccessDialog>
            </>
          )}
        </EstimatedQuoteCard>
      ) : (
        <p className="text-center text-sm text-gray-600">
          Something went wrong, please try again!
        </p>
      )}

      <div className="space-x-4 flex justify-between items-center">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="w-[73px] h-[44px] px-2 text-custom-blue font-medium border border-custom-blue rounded-lg"
        >
          Back
        </button>

        {/* <button
          type="submit"
          className="w-[100px] h-[44px] rounded-md bg-[#0348B7] text-white font-medium"
        >
     
          Next
        </button> */}
      </div>
    </section>
  );
}
